import { COUNTRIES } from "../constants/options";

export const CountryPicker = ({ value, onChange, className = "", testId = "search-country-select" }) => (
  <div className={`flex border border-white/15 ${className}`} data-testid={testId}>
    {[{ name: "", short: "All" }, ...COUNTRIES].map((c) => (
      <button
        key={c.short}
        type="button"
        onClick={() => onChange(c.name)}
        className={`flex-1 px-3 py-2 text-xs font-bold uppercase tracking-wider transition-colors ${value === c.name ? "bg-primary text-primary-foreground" : "text-white/70 hover:text-white"}`}
        data-testid={`${testId}-${c.short.toLowerCase()}`}
      >
        {c.short}
      </button>
    ))}
  </div>
);
